import cookie from 'js-cookie';

import { USER_INFO } from 'Utils/ple-utils/cookies';
import createAction from 'Store/utils/createAction';

export const SIGNOUT = 'SIGNOUT';

function cleanCookies() {
  cookie.remove(USER_INFO);
}

export default function signout() {
  cleanCookies();
  return createAction(SIGNOUT);
}
